<!--
 * @Author: 'qhy' '272921690@qq.com'
 * @Date: 2022-11-22 13:58:28
 * @LastEditors: 'qhy' '272921690@qq.com'
 * @LastEditTime: 2023-03-20 14:08:13
 * @FilePath: \edu_ytsr_show_total_vue\src\components\tabBanner.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="public-width">
    {{ tab_index }}
    <div v-for="(item, index) in tabList" :key="index" @click="changeType(index, item.id)">
      <span :class="t_index == index ? 'active' : ''" class="tab">{{ item.columnType }}</span>
      <el-divider direction="vertical" v-if="index != (tabList.length - 1)"></el-divider>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      t_index: -1
    }
  },
  props: {
    tab_index: {
      type: Number,
      default:()=>{}
    },
    tabList: {
      type: Array,
      default: () => { }
    }

  },
  methods: {
    changeType(index, id) {
      // this.t_index = index
      this.$emit('changeType', id)
    }
  },
  created() {
    if (this.tabList[0].id != "") {
      const index = this.tabList.findIndex(object => object.columnType === '全部');
      if (index === -1) {
        this.tabList.push({ id: "", columnType: '全部' });
      }
    }
    if (this.tab_index != -1) {
      this.t_index = this.tab_index
    }else{
      this.t_index = this.tabList.length - 1
    }
    
  }
}
</script>
<style lang="scss" scoped>
.public-width {
  height: 50px;
  line-height: 50px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;

  .tab {
    display: inline-block;
    width: 100px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }

  .active {
    font-weight: bold;
  }
}
</style>